export const AuthTokenConstants = {
  TOKEN_EXPIRY_KEY: 'token_expiry',
  TOKEN_DURATION_KEY: 'token_duration_minutes',
  LAST_ACTIVITY_KEY: 'last_activity',
  SESSION_SYNC: 'session_sync',
  SHOW_MODAL_KEY: 'show_timeout_modal',
  AUTH_LOGGING_OUT: 'auth_logging_out',
  CO_BROWSING_EMAIL: 'co_browsing_email',
  COBROWSING_COMPANY: 'co_browsing_company',
  COBROWSING_DNV_USER_ACCESS: 'co_browsing_dnv_user_access',
};
